import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Confetti from 'react-confetti';
import { useAuth } from '../context/AuthContext';
import { Button, Container, Title, Text, Center } from '@mantine/core';
import { supabase } from '../supabase/client';

const CongratulationsPage: React.FC = () => {
  const { testId } = useParams();
  const { user } = useAuth();
  const [score, setScore] = useState<number | null>(null);
  const navigate = useNavigate();

  // For Confetti sizing
  const [width, setWidth] = useState<number>(window.innerWidth);
  const [height, setHeight] = useState<number>(window.innerHeight);

  // Update confetti size on window resize
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Call the calculate_score RPC after the test is submitted
  useEffect(() => {
    if (!testId || !user) return;

    const fetchScore = async () => {
      try {
        const { data, error } = await supabase.rpc('calculate_score', {
          testid: testId,
          profileid: user.id,
        });
        if (error) {
          console.error('Error calling calculate_score:', error);
          navigate('/dashboard');
          return;
        }
        setScore(data);
      } catch (err) {
        console.error('Unexpected error:', err);
      }
    };

    fetchScore();
  }, [testId, user]);

  return (
    <>
      {/* Confetti overlay */}
      <Confetti initialVelocityY={3} gravity={0.03} numberOfPieces={200} tweenDuration={10_000} recycle={false} width={width} height={height} />

      <Container>
        <Center style={{ minHeight: '70vh', flexDirection: 'column' }}>
          <Title order={1} mb="md">
            Congratulations!
          </Title>
          <Text size="lg" mb="md">
            You have successfully submitted your test.
          </Text>

          {score !== null ? (
            <Title order={2} c="green" mb="xl">
              Your Score: {score}
            </Title>
          ) : (
            <Text size="sm" c="dimmed" mb="xl">
              Calculating your score...
            </Text>
          )}

          <Button component={Link} to="/dashboard" variant="outline">
            Go back to Dashboard
          </Button>
        </Center>
      </Container>
    </>
  );
};

export default CongratulationsPage;
